export function formatAmount(desiredUom, value) {
    var _a = value.split('.'), integerPart = _a[0], _b = _a[1], fraction = _b === void 0 ? '' : _b;
    var truncatedValue = integerPart
        ? "".concat(integerPart).concat(desiredUom.allowFractional ? ".".concat(fraction.slice(0, 1)) : '')
        : '';
    var skipParseFloat = truncatedValue === '' || (desiredUom.allowFractional && value[value.length - 1] === '.');
    return skipParseFloat ? truncatedValue : parseFloat(truncatedValue);
}
//# sourceMappingURL=utils.js.map